import { Controller } from "@hotwired/stimulus";
import Tabulator from "../lib/tabulator";

export default class extends Controller {
  connect() {
    const tableEl =
      this.element.tagName === "TABLE"
        ? this.element
        : this.element.querySelector("table");
    if (!tableEl) return;

    const rows = Array.from(tableEl.querySelectorAll("tbody tr")).map((row) => {
      const obj = {};
      Array.from(row.querySelectorAll("td")).forEach((td, i) => {
        obj[`c${i}`] = td.innerHTML;
      });
      return obj;
    });

    const columns = Array.from(tableEl.querySelectorAll("thead th")).map(
      (th, i) => ({
        title: th.textContent.trim(),
        field: `c${i}`,
        formatter: "html",
        hozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerHozAlign: th.classList.contains("text-end") ? "right" : "left",
        headerFilter: "input",
      })
    );

    this.tabulator = new Tabulator(tableEl, {
      data: rows,
      columns: columns,
      layout: "fitColumns",
      selectable: false,
    });
  }

  disconnect() {
    this.tabulator?.destroy();
  }
}
